import { Pipe, PipeTransform } from '@angular/core';
import { BaseService } from '../../shared-service/base.service';
import { DataService } from '../../shared-service/data.service';

@Pipe({
  name: 'searchCard',
  pure: true
})
export class SearchCardPipe implements PipeTransform {

  constructor(private bs: BaseService, private ds: DataService) {

  }

  transform(searchCardDetail: any, args?: any): any {

    if (searchCardDetail.ItemTypeId == undefined)
      searchCardDetail.ItemTypeId = searchCardDetail.LearningTypeItemId;
    let returnvalue = '';
    switch (args) {
      case "icon":
        returnvalue = this.getIcon(searchCardDetail);
        break;
      case "image":
        returnvalue = this.getImage(searchCardDetail);
        break;
      case "iconbg":
        returnvalue = this.getIconBgColor(searchCardDetail);
        break;
      case "typename":
        returnvalue = this.getTypeName(searchCardDetail);
        break;
      case "itemname":
        returnvalue = this.getItemName(searchCardDetail);
        break;
      case "filecounttext":
        returnvalue = this.getFileCountText(searchCardDetail);
        break;
    }

    return returnvalue;
  }

  getIcon(searchCardDetail: any) {

    let iconClass = "";
    if (searchCardDetail.ItemTypeCode == 'C' || searchCardDetail.ItemTypeCode == 'T') {
      switch (searchCardDetail.ItemTypeId) {
        case 1:
          iconClass = "icons_assessment";
          break;
        case 2:
          iconClass = "icons_assignment";
          break;
        case 3:
          iconClass = "icons_elearning";
          break;
        case 4:
          iconClass = "icons_training";
          break;
        case 5:
          iconClass = "icons_play";
          break;
        case 6:
          iconClass = "icons_clone";
          break;
        case 7:
          iconClass = "icons_clone";
          break;
        case 9:
          iconClass = "icons_play";
          break;
        case 10:
          iconClass = "icons_clone";
          break;
        case 11:
          iconClass = "icons_checklist";
          break;
        default:
          iconClass = "icons_clone";
          break;
      }
    }
    else {
      if (searchCardDetail.ItemTypeCode == 'D') {
        iconClass = "icons_support_b";
      }
      else if (searchCardDetail.ItemTypeCode == 'V') {
        iconClass = "icons_play";
      }
      else if (searchCardDetail.ItemTypeCode == 'S') {
        iconClass = "icons_survey";
      }
      else if (searchCardDetail.ItemTypeCode == 'B') {
        if (searchCardDetail.IsFile == true || searchCardDetail.IsFile == 'true')
          iconClass = "icons_file";
        else
          iconClass = "icons_FlFolder";
      }
    }
    return iconClass;
  }

  getImage(searchCardDetail: any) {
    let imageUrl = this.bs.config.apiBaseUrl + 'Middleware/ThumbnailGenerator.aspx?LoggedIn=0&Canvas=true&ImageWidth=198&ImageHeight=132&ImageFile=';
    if (searchCardDetail.ItemThumbnailPath != undefined && searchCardDetail.ItemThumbnailPath.trim().length > 0) {
      if (searchCardDetail.ItemThumbnailPath.indexOf("ThumbnailGenerator.aspx") > -1) {
        imageUrl = searchCardDetail.ItemThumbnailPath;
      }
      else if(searchCardDetail.IsExternalContent == true && searchCardDetail.IsFromProvider == true){
        imageUrl = searchCardDetail.ItemThumbnailPath;
      }
      else {
        imageUrl = imageUrl + searchCardDetail.ItemThumbnailPath;
      }
    }

    else if (searchCardDetail.ItemTypeCode == 'C' || searchCardDetail.ItemTypeCode == 'T') {
      imageUrl += "/Content/Specific/Images/";
      switch (searchCardDetail.ItemTypeId) {
        case 1:
          imageUrl = imageUrl + "Assessment.png";
          break;
        case 2:
          imageUrl = imageUrl + "Assignment.jpg";
          break;
        case 3:
          imageUrl = imageUrl + "Elearning.png";
          break;
        case 4:
          imageUrl = imageUrl + "ILT.jpg";
          break;
        case 5:
          imageUrl = imageUrl + "ILT.jpg";
          break;
        case 6:
          imageUrl = imageUrl + "LearningMaterial.png";
          break;
        case 7:
          imageUrl = imageUrl + "Video.png";
          break;
        case 9:
          imageUrl = imageUrl + "Elearning.png";
          break;
        case 10:
          imageUrl = imageUrl + "Elearning.png";
          break;
        case 11:
          imageUrl = imageUrl + "checklist.png";
          break;
        default:
          imageUrl = imageUrl + "Elearning.png";
          break;
      }
    }
    else {
      imageUrl += "/Content/Specific/Images/";
      if (searchCardDetail.ItemTypeCode == 'D') {
        imageUrl = imageUrl + "Conversation.PNG";
      }
      else if (searchCardDetail.ItemTypeCode == 'V') {
        imageUrl = imageUrl + "Video.png";
      }
      else if (searchCardDetail.ItemTypeCode == 'S') {
        imageUrl = imageUrl + "Survey.PNG";
      }
      else if (searchCardDetail.ItemTypeCode == 'B') {
        imageUrl = imageUrl + "briefcasedefaultImage.JPG";
      }
    }
    return imageUrl;
  }

  getIconBgColor(searchCardDetail: any) {
    let iconBgColor = "";
    if (searchCardDetail.ItemTypeCode == 'C' || searchCardDetail.ItemTypeCode == 'T') {
      switch (searchCardDetail.ItemTypeId) {
        case 1:
          iconBgColor = "play_icon_wrap assessment_type_bg";
          break;
        case 2:
          iconBgColor = "play_icon_wrap assignment_type_bg";
          break;
        case 3:
          iconBgColor = "play_icon_wrap elearning_type_bg";
          break;
        case 4:
          iconBgColor = "play_icon_wrap training_typ_bg";//Training
          break;
        case 5:
          iconBgColor = "play_icon_wrap light_purple_bg";//video
          break;
        case 6:
          iconBgColor = "play_icon_wrap green_bg";//Learning Material
          break;
        case 7:
          iconBgColor = "play_icon_wrap green_bg";//External learning
          break;
        case 9:
          iconBgColor = "play_icon_wrap light_purple_bg";//video
          break;
        case 10:
          iconBgColor = "play_icon_wrap green_bg";//Read & sign
          break;
        case 11:
          iconBgColor = "play_icon_wrap checklist_type_bg";//Checklist
          break;
        default:
          iconBgColor = "play_icon_wrap green_bg";//All Learning
          break;
      }
    }
    else {
      if (searchCardDetail.ItemTypeCode == 'D') {
        iconBgColor = "play_icon_wrap darkpink_bg";
      }
      else if (searchCardDetail.ItemTypeCode == 'V') {
        iconBgColor = "play_icon_wrap light_purple_bg";
      }
      else if (searchCardDetail.ItemTypeCode == 'S') {
        iconBgColor = "play_icon_wrap cyan_bg";
      }
      else if (searchCardDetail.ItemTypeCode == 'B') {
        iconBgColor = "play_icon_wrap yellow_dark_bg";
      }
    }
    return iconBgColor;
  }

  getTypeName(searchCardDetail: any) {
    let typeName = "";
    if (searchCardDetail.IsExternalContent == true) {
      typeName = searchCardDetail.ProviderName;
    }
    else {
      if (searchCardDetail.ItemTypeCode == 'C' || searchCardDetail.ItemTypeCode == 'T') {
        switch (searchCardDetail.ItemTypeId) {
          case 1:
            typeName = this.bs.getResource("rbkey_AssssmntLBL");
            break;
          case 2:
            typeName = this.bs.getResource("rbkey_AssgnmntLBL");
            break;
          case 3:
            typeName = this.bs.getResource("rbkey_PrgrmLbL");
            break;
          case 4:
            typeName = this.bs.getResource("rbkey_TrnngLBL");
            break;
          case 5:
            typeName = this.bs.getResource("rbkey_VdLBL");
            break;
          case 6:
            typeName = this.bs.getResource("rbkey_ELrnngLBL");
            break;
          case 7:
            typeName = this.bs.getResource("rbkey_ExtrnlLrnngLBL");
            break;
          case 9:
            typeName = this.bs.getResource("rbkey_VdLBL");
            break;
          case 10:
            typeName = this.bs.getResource("rbkey_RdSgnLrng");
            break;
          case 11:
            typeName = this.bs.getResource("rbkey_ChcklstLBL");
            break;
          case 12:
            typeName = this.bs.getResource("rbkey_ExtrnlCntnLbl");
            break;
          default:
            typeName = this.bs.getResource("rbkey_ELrnngLBL");
            break;
        }
      }
      else {
        if (searchCardDetail.ItemTypeCode == 'D') {
          typeName = this.bs.getResource("rbkey_CnvrstnLBL");
        }
        else if (searchCardDetail.ItemTypeCode == 'V') {
          typeName = this.bs.getResource("rbkey_VdLBL");
        }
        else if (searchCardDetail.ItemTypeCode == 'S') {
          typeName = this.bs.getResource("rbkey_SrvyLBL");
        }
        else if (searchCardDetail.ItemTypeCode == 'B') {
          if (searchCardDetail.IsFile) {
            typeName = 'File';
          }
          else {
            typeName = 'Folder';
          }
        }
      }
    }
    return typeName;
  }

  getItemName(searchCardDetail: any) {
    let itemName = "";
    if (searchCardDetail.ItemTypeCode == 'B' && searchCardDetail.ParentId > 0) {
      itemName = searchCardDetail.ItemName + ' (' + searchCardDetail.ParentName + ')';
    }
    else {
      itemName = searchCardDetail.ItemName;
    }
    return itemName;
  }

  getFileCountText(searchCardDetail: any) {
    let filecounttext = "";
    if (searchCardDetail.ItemTypeCode == 'B' && searchCardDetail.IsFile) {
      filecounttext = searchCardDetail.FileType;
    }
    else {
      filecounttext = searchCardDetail.TotalFilesCount + " File(s)";
    }
    return filecounttext;
  }

}
